import React, { useEffect } from "react";

import { useAppDispatch, useAppSelector } from "../../../State/Store";
import { fetchUserOrderHistory } from "../../../State/customer/OrderSlice";
import { OrderPackage } from "./OrderPackage";

export const Orders = () => {
  const dispatch = useAppDispatch();
  const { order } = useAppSelector((store) => store);
  useEffect(() => {
    dispatch(fetchUserOrderHistory());
  }, []);

  return (
    <div className="text-sm min-h-screen px-7 xl:px-10">
      <div className="pb-5">
        <h1 className="text-2xl font-bold text-gray-600">All Orders</h1>
        <p className="text-xl ">From any time</p>
      </div>
      <div className="space-y-2">
        {order.orders&& order.orders.length>0 ?order.orders.map((order, orderIndex) =>
        <OrderPackage key={orderIndex} order={order}/>
          // orderItem.orderItems.map((item, index) => (
          //   <OrderItem item={item} order={orderItem} key={`${orderIndex}-${index}`} />
          // ))
        ):(
          <h1 className="text-primary text-center font-semibold text-2xl">No Order Was Found</h1> 
        )}
      </div>
    </div>
  );
};
